<!-- messaggio ok dopo registrazione utente -->
<mat-card class="p-0">
  <mat-card-content>
    <div style="width:100%; background-color: #ffffff; text-align: left;  ">
      <div class="container">

        <div class="row" style="text-align: center;">
          <img src="{{lstPercorsoImmagine}}" alt="Ok.jpg" width="50" height="50" />

        </div>
        <div class="row">
          <label>
            <mat-icon>arrow_forward</mat-icon>
            Sei stato iscritto a Newsletter Gii-Idraulica.
          </label>
          <br />
          <label>
            <mat-icon>arrow_forward</mat-icon>
            Ti ringraziamo per aver fatto la richiesta di un profilo utente.
            Il tuo profilo utente è attualmente in attesa di approvazione da parte dell'amministratore del sito.
            Nel frattempo un messaggio di benvenuto con ulteriori istruzioni è stato inviato al tuo indirizzo e-mail.
          </label>.
        </div>

        <div class="row">
        <div fxFlex="100%;" fxFlex.xs="100%">
                  <button mat-raised-button color="accent" style="float: right !important;"
                          (click)="btnEsci()">
                    Esci
                  </button>
                </div>
        </div>
      </div>
    </div>

  </mat-card-content>
</mat-card>
<style>

  .inserimento-form { 
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }
</style>
